PJQ.views.projects.QuickAddParticipantsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Quick-Add-Participants'),
		minWidth: '400px',
		onSave: null
	},
	events: {
		'keyup .input-email': 'emailChanged',
		'click .btn-add': 'addParticipant'
	},
	emailChanged: function (e) {
		this.$('.btn-add').prop('disabled', _.size($(e.currentTarget).val()) === 0);
	},
	addParticipant: function () {
		let emails = this.$('.input-email').val().split(';');
		_.each(emails, function (email) {
			let newParticipant = new PJQ.models.projectParticipants.ProjectParticipant({
				project: this.options.project,
				email: email,
				groups: null,
				isQuickAdd: true
			});
			newParticipant.save(null, {
				notify: false,
				success: _.bind(function (mod, data) {
					if (newParticipant.get('projectId') == null && newParticipant.groups != null && _.size(newParticipant.groups.models) > 0) {
						newParticipant.set({
							id: null,
							projectId: this.options.project.id
						});
						new PJQ.views.groups.SelectGroupsModal({
							alertText: 'Select trades to add with this participant',
							selectorOptions: {
								includeGroupIds: _.map(newParticipant.groups.models, function (group) {
									return group.id;
								})
							},
							onSave: _.bind(function (groups) {
								newParticipant.groups.reset(groups.selected);
								newParticipant.save(null, {
									notify: false,
									success: _.bind(function (mod, data) {
										this.removeModal();
										if (typeof this.options.onSave === 'function') {
											this.options.onSave(newParticipant);
										}
									}, this),
									error: _.bind(function () {
										PJQ.notifications.notify.errorNotify({
											message: newParticipant.get('email') + ' already exists on this project.'
										});
									}, this)
								});
							}, this)
						});
					}
					else {
						this.removeModal();
						if (typeof this.options.onSave === 'function') {
							this.options.onSave(newParticipant);
						}
					}
				}, this),
				error: _.bind(function () {
					PJQ.notifications.notify.errorNotify({
						message: newParticipant.get('email') + ' already exists on this project.'
					});
				}, this)
			});
		}, this);
	}
});